import React, { useState } from 'react'

export const Search = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const [searchString, setSearchString] = useState('')

  const onKeyUp = (event) => {
    if (event.key === 'Enter') {
      window.location.href = govCMSHome + '/search?keys=' + event.target.value
    }
  }

  return (
    <div className="content">
      <div className="form-search site-search minimal">
        <div id="_Search_14815_SearchPanel" className="searchPanel ">
          <label htmlFor="_Search_14815_strSearchKeyword">Search</label>
          <input
            name="searchKeyword"
            placeholder="Search"
            type="text"
            maxLength={100}
            id="_Search_14815_strSearchKeyword"
            className="clsnormal555555 searchInput form-control"
            title="Search"
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            onKeyPress={onKeyUp}
          />
          <span
            id="_Search_14815_SearchKeywordValidator"
            style={{ display: 'none' }}
          >
            *
          </span>
          <a
            id="_Search_14815_SearchLinkButton"
            href={govCMSHome + '/search?keys=' + searchString}
            className="btn btn-primary"
          >
            Search
          </a>
        </div>
        <h3>Popular searches</h3>

        <ul className="popularKeywordList">
          <li>
            <a href={govCMSHome + '/search?keys=minimum-wages'}>
              minimum wages
            </a>
          </li>
          <li>
            <a href={govCMSHome + '/search?keys=annual leave'}>annual leave</a>
          </li>
          <li>
            <a href={govCMSHome + '/search?keys=long service leave'}>
              long service leave
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}
